import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import PulseLoader from "react-spinners/PulseLoader";
import { statusList } from "../../data";
import { getDataWithToken } from "../../services/GetDataService";
import { handlePutData } from "../../services/PutDataService";
import { customTextField } from "./technicianStyles";

const getCurrentRepairStatus = (foundRepair) => {
  if (foundRepair?.repair_status) {
    return foundRepair.repair_status;
  }
  const history = foundRepair?.repair_status_history_data;
  if (history?.length) {
    return history[history.length - 1]?.repair_status_name || "";
  }
  return "";
};

const updateRepairTechnician = async (
  repairData,
  status,
  remarks,
  repairBy,
) => {
  const lastHistory = repairData?.repair_status_history_data?.length
    ? repairData.repair_status_history_data[
        repairData.repair_status_history_data.length - 1
      ]
    : null;

  const data = {
    delivery_status:
      repairData?.delivery_status ||
      lastHistory?.repair_delivery_status_name ||
      "",
    repair_status: status,
    repair_status_remarks: remarks,
    repair_by: repairBy,
  };

  return handlePutData(
    `/api/v1/repair/technician-update/${repairData._id}`,
    data,
    false,
  );
};

const RepairForm = ({
  repair,
  token,
  logout,
  technicianList = [],
  onNotify,
  onRepairUpdated,
}) => {
  const [repairStatus, setRepairStatus] = useState("");
  const [repairStatusRemarks, setRepairStatusRemarks] = useState("");
  const [repairBy, setRepairBy] = useState("");
  const [updateLoading, setUpdateLoading] = useState(false);

  useEffect(() => {
    if (repair) {
      setRepairStatus(getCurrentRepairStatus(repair));
      setRepairStatusRemarks("");
      // setRepairBy(repair?.repair_by || "");
    }
  }, [repair]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!repair?._id) {
      onNotify("Please search a repair first", "error");
      return;
    }
    if (!repairStatus) {
      onNotify("Repair status is Required", "error");
      return;
    }

    const originalRepairStatus = getCurrentRepairStatus(repair);
    const hasRepairStatusChanged = repairStatus !== originalRepairStatus;
    // const hasRepairByChanged = repairBy !== (repair?.repair_by || "");

    if (!hasRepairStatusChanged) {
      onNotify("Nothing to update", "error");
      return;
    }

    setUpdateLoading(true);

    const response = await updateRepairTechnician(
      repair,
      repairStatus,
      repairStatusRemarks,
      // repairBy,
    );

    if (response?.status === 401) {
      logout();
      return;
    }

    if (!(response?.status >= 200 && response?.status < 300)) {
      setUpdateLoading(false);
      onNotify(
        response?.data?.message?.toString() || "Failed to update repair",
        "error",
      );
      return;
    }

    onNotify("Updated successfully", "success");
    setRepairStatusRemarks("");

    if (repair?.repair_id) {
      const refreshed = await getDataWithToken(
        `/api/v1/repair/find?repair_id=${encodeURIComponent(repair.repair_id)}`,
        token,
      );
      if (refreshed?.status >= 200 && refreshed?.status < 300) {
        const payload = refreshed?.data?.data;
        const foundRepair = Array.isArray(payload) ? payload[0] : payload;
        if (foundRepair?._id || foundRepair?.repair_id) {
          onRepairUpdated(foundRepair);
          setRepairStatus(getCurrentRepairStatus(foundRepair));
        }
      }
    } else {
      onRepairUpdated({
        ...repair,
        repair_status: repairStatus,
      });
    }

    setUpdateLoading(false);
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ textAlign: "left" }}>
      <FormControl fullWidth size="small" sx={{ mb: 1.5 }}>
        <InputLabel id="technician-repair-status-label">
          Repair Status
        </InputLabel>
        <Select
          labelId="technician-repair-status-label"
          id="technician-repair-status"
          label="Repair Status"
          value={repairStatus}
          onChange={(e) => setRepairStatus(e.target.value)}
        >
          {statusList.map((item) => (
            <MenuItem key={item.name} value={item.name}>
              {item.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <TextField
        sx={{ ...customTextField, mb: 1.5 }}
        label="Note"
        fullWidth
        size="small"
        id="technician-repair-status-remarks"
        value={repairStatusRemarks}
        onChange={(e) => setRepairStatusRemarks(e.target.value)}
      />

      {/* <FormControl fullWidth size="small" sx={{ mb: 1.5 }}>
        <InputLabel id="technician-repair-by-label">Repair By</InputLabel>
        <Select
          labelId="technician-repair-by-label"
          id="technician-repair-by"
          label="Repair By"
          value={repairBy}
          onChange={(e) => setRepairBy(e.target.value)}
          MenuProps={{
            PaperProps: {
              sx: {
                maxHeight: 250,
                "& .MuiMenuItem-root": { fontSize: "14px" },
              },
            },
          }}
        >
          {technicianList.map((item) => (
            <MenuItem key={item?._id} value={item?._id}>
              {item?.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl> */}
      <Button
        variant="contained"
        color="success"
        fullWidth
        size="small"
        type="submit"
        disabled={updateLoading}
        sx={{ minHeight: 40, mb: 1.5, fontSize: 14 }}
      >
        {updateLoading === false && "Update"}
        <PulseLoader
          color="#16bb3aff"
          loading={updateLoading}
          size={8}
          speedMultiplier={0.5}
        />
      </Button>
    </Box>
  );
};

export default RepairForm;
